import { FormApiContext, withErrorBoundary } from '../utils';
import { queryAddOns } from '@wix/ambassador-addons-v1-add-on/http';
import {
  QueryAddOnsRequest,
  QueryAddOnsResponse,
} from '@wix/ambassador-addons-v1-add-on/types';
import { ServerErrorType } from '../../../types/errors';

export interface QueryAddonsArgs {
  queryAddOnsRequest: QueryAddOnsRequest;
}

export const queryAddons = async ({
  httpClient,
  reportError,
  queryAddOnsRequest,
}: FormApiContext & QueryAddonsArgs): Promise<QueryAddOnsResponse> => {
  const { data, error } = await withErrorBoundary(
    {
      fn: async () => {
        const response = await httpClient.request(
          queryAddOns(queryAddOnsRequest),
        );
        return response.data;
      },
      mapError: (e: any) => {
        // Handle specific error cases
        if (e?.response?.status === 404) {
          return {
            error: ServerErrorType.INVALID_SERVICE_ID,
            shouldReport: false,
          };
        }
        if (e?.response?.status === 400) {
          return {
            error: ServerErrorType.INVALID_ADDONS_DATA,
            shouldReport: true,
          };
        }
        // Network or unexpected errors
        return {
          error: ServerErrorType.GENERAL_SERVER_ERROR,
          shouldReport: true,
          additionalData: { originalError: e?.message },
        };
      },
      fallback: {
        addOns: [],
      },
    },
    reportError,
  );

  if (error) {
    throw error;
  }

  return data!;
};
